import { truncateMiddle } from '@/utils/tools'

const MediaFooter = ({ selected, handleSelectionToggle, id, name }) => {
    return (
        <div className="d-flex align-items-center gap-2 mt-2 tw:z-1">
            <input type="checkbox" checked={selected} onChange={() => handleSelectionToggle(id)} />
            {name && (
                <div className="tooltip tooltip-normal p-0" style={{ display: 'inline' }}>
                    <label onClick={() => handleSelectionToggle(id)} style={{ cursor: 'pointer' }}>
                        {truncateMiddle(name)}
                    </label>
                    <span className="tooltiptext tooltiptext-big">{name}</span>
                </div>
            )}
        </div>
    )
}

export default MediaFooter
